import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import Document from "./Accountings/Document";
import DatePicker from 'react-datepicker2';

export default class ExploreReport extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            data: null,
            loading: true,
            fromDate: null,
            toDate: null,
            configName: 'explore_report',
            isReverse: props.IsReverse,
            systemModuleId: 8,
            moduleAccessStatus: 1,
            menuId: 57
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;

                this.getData();
            });
    }
    componentWillReceiveProps(props) {
        this.state.id = props.Id;
        this.getData();
    }
    getData() {
        this.httpPost("api/v1/report/explore", {
            isReverse: this.state.isReverse,
            id: this.getCurrentFormId(),
            fromDate: this.convertMomentToDb(this.state.fromDate),
            toDate: this.convertMomentToDb(this.state.toDate),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    showDocument(id) {
        this.showComponents({ component: <Document Caller={this} Id={id} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "fullCode", caption: "کدحساب", show: true },
                { field: "title", caption: "نام حساب", show: true },
                { field: "bed", caption: "گردش بدهکار", show: true },
                { field: "bes", caption: "گردش بستانکار", show: true },
                { field: "remainBed", caption: "مانده بدهکار", show: true },
                { field: "remainBes", caption: "مانده بستانکار", show: true },
            ]
        }
    }

    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'fullCode' && f.show) t.push({
                field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => {
                    if (!this.state.isReverse) {
                        if (props.data.accountType > 3) {
                            if (!this.isNull(this.state.data.moein))
                                return <NavLink className="text-primary txt-bold hand" to={"/report/transactions/overview/" + props.data.id + "/" + this.state.data.moein.id + "/"}>{props.data.fullCode}</NavLink>
                            return <NavLink className="text-primary txt-bold hand" to={"/report/transactions/" + props.data.id + "/" + this.state.data.moein.id + "/"}>{props.data.fullCode}</NavLink>
                        }
                        if (props.data.accountType === 3 && !this.isNull(this.state.data.moein))
                            return <NavLink className="text-primary txt-bold hand" to={"/report/transactions/" + props.data.id + "/" + this.state.data.moein.id + "/"}>{props.data.fullCode}</NavLink>

                        return <NavLink className="text-primary txt-bold hand" to={"/report/explore" + props.data.accountType + "/" + props.data.id + "/"}>{props.data.fullCode}</NavLink>
                    }
                    else {
                        if (props.data.accountType > 1)
                            return <NavLink className="text-primary txt-bold hand" to={"/report/explore" + (props.data.accountType - 1) + "u/" + props.data.id + "/"}>{props.data.fullCode}</NavLink>
                        else
                            return props.data.fullCode;
                    }
                }
            });
            if (f.field == 'title' && f.show) t.push({
                field: f.field, flex: 2, headerName: f.caption, cellRenderer: (props) => {
                    if (!this.state.isReverse) {
                        if (props.data.accountType > 3) {
                            if (!this.isNull(this.state.data.moein))
                                return <NavLink className="text-primary txt-bold hand" to={"/report/transactions/overview/" + props.data.id + "/" + this.state.data.moein.id + "/"}>{props.data.title}</NavLink>
                            return <NavLink className="text-primary txt-bold hand" to={"/report/transactions/" + props.data.id + "/" + this.state.data.moein.id + "/"}>{props.data.title}</NavLink>
                        }
                        if (props.data.accountType === 3 && !this.isNull(this.state.data.moein))
                            return <NavLink className="text-primary txt-bold hand" to={"/report/transactions/" + props.data.id + "/" + this.state.data.moein.id + "/"}>{props.data.title}</NavLink>

                        return <NavLink className="text-primary txt-bold hand" to={"/report/explore" + props.data.accountType + "/" + props.data.id + "/"}>{props.data.title}</NavLink>
                    }
                    else {
                        if (props.data.accountType > 1)
                            return <NavLink className="text-primary txt-bold hand" to={"/report/explore" + (props.data.accountType - 1) + "u/" + props.data.id + "/"}>{props.data.title}</NavLink>
                        else
                            return props.data.title;
                    }
                }
            });
            if (f.field == 'bed' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bed) } });
            if (f.field == 'bes' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bes) } });
            if (f.field == 'remainBed' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.remainBed) } });
            if (f.field == 'remainBes' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.remainBes) } });
        });
        return t;
    }
    renderFilters() {
        var res = [];

        if (!this.isNull(this.state.data.group)) {
            if (!this.state.isReverse)
                res.push(<NavLink to="/report/explore/" className="hand badge rounded-pill bg-danger me-1">مرورحسابها از کل به جز</NavLink>);
            else
                res.push(<NavLink to="/report/explore/" className="hand badge rounded-pill bg-danger me-1">مرورحسابها از جز به کل</NavLink>);
        }

        if (!this.state.isReverse) {
            if (!this.isNull(this.state.data.group))
                res.push(<NavLink to={"/report/explore1/" + this.state.data.group.id} className="badge rounded-pill bg-info mr-2">{this.state.data.group.title}</NavLink>);
            if (!this.isNull(this.state.data.kol))
                res.push(<NavLink to={"/report/explore2/" + this.state.data.kol.id} className="badge rounded-pill bg-info mr-2">{this.state.data.kol.title}</NavLink>);
            if (!this.isNull(this.state.data.moein))
                res.push(<NavLink to={"/report/explore3/" + this.state.data.moein.id} className="badge rounded-pill bg-info mr-2">{this.state.data.moein.title}</NavLink>);
        }
        else {
            if (!this.isNull(this.state.data.kol))
                res.push(<NavLink to={"/report/explore1/" + this.state.data.kol.id} className="badge rounded-pill bg-info mr-2">از جز  {this.state.data.kol.title}</NavLink>);
            if (!this.isNull(this.state.data.moein))
                res.push(<NavLink to={"/report/explore2/" + this.state.data.moein.id} className="badge rounded-pill bg-info mr-2">از جز  {this.state.data.moein.title}</NavLink>);
            if (!this.isNull(this.state.data.tafsil))
                res.push(<NavLink to={"/report/transactions/" + this.state.data.tafsil.id} className="badge rounded-pill bg-info mr-2">از جز  {this.state.data.tafsil.title}</NavLink>);
        } return res;
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div className="container">
                <div className="col-sm-2 text-left">
                    <ul className="nk-block-tools g-3">
                        <li>
                            <a className="btn btn-white btn-outline-light" onClick={e => this.onPrint('مرور حسابها')}><span>چاپ</span></a>
                        </li>
                        <li>
                            <a className="btn btn-white btn-outline-light" onClick={e => this.onPdf('مرور حسابها')}><span>PDF</span></a>
                        </li>
                        <li>
                            <a className="btn btn-white btn-outline-light" onClick={e => this.onExcel('مرور حسابها')}><span>اکسل</span></a>
                        </li>
                    </ul>
                </div>
            <div>
                {this.renderFilters()}
            </div>
            <div className="form-inline flex-nowrap gx-3">
                <div className="form-wrap">
                    <DatePicker
                        inputReadOnly={false}
                        className="form-control persian-date ltr"
                        placeholder={"از تاریخ"}
                        isGregorian={false}
                        showTodayButton={true}
                        timePicker={false}
                        onChange={(e) => { this.state.fromDate = e }}
                        value={this.getFormatedDateForDatePicker(this.state.fromDate)}
                    />
                </div>
                <div className="form-wrap">
                    <DatePicker
                        inputReadOnly={false}
                        className="form-control persian-date ltr"
                        placeholder={"تا تاریخ"}
                        isGregorian={false}
                        showTodayButton={true}
                        timePicker={false}
                        onChange={(e) => { this.state.toDate = e }}
                        value={this.getFormatedDateForDatePicker(this.state.toDate)}
                    />
                </div>
                <div className="btn-wrap">
                    <span className="d-none d-md-block"><button onClick={e => this.getData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> نمایش</button></span>
                </div>
            </div>
            {this.renderAgGrid({
                columnDefs: this.getColumns(),
            })}
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                this.getGlobalContainer(),
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.isEmpty(this.state.data.global.annuals) ? this.renderNoAnnual() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                this.renderPopupComponent(),
                <Footer />
            ];

        return contents;
    }
}